import { css } from '@emotion/react';
import { menuItemClasses } from '@mui/material';

import { menuItemContentClasses } from '../MenuItemContent/theme';

import type { ThemeOptions } from '@mui/material';

export const menuItemThemes: ThemeOptions['components'] = {
  MuiMenuItem: {
    defaultProps: {
      color: 'default',
      disableRipple: true,
      disableTouchRipple: true,
    },
    styleOverrides: {
      root: ({ theme, ownerState }) => css`
        min-height: auto;

        &,
        &.${menuItemClasses.selected},
          &.${menuItemClasses.focusVisible},
          &.${menuItemClasses.selected}.${menuItemClasses.focusVisible} {
          background-color: ${theme.color['base/transparent']};
        }

        &:hover,
        &.${menuItemClasses.selected}:hover {
          background-color: ${ownerState.color !== 'global'
            ? theme.color['surface/transparent/hover']
            : theme.color['surface/global/strong/hover']};
        }

        ${theme.mixins.focusRing('inside', {
          selectors: { focus: `&.${menuItemClasses.focusVisible}` },
          inverse: ownerState.color === 'global',
        })}
        &:active {
          background-color: ${ownerState.color !== 'global'
            ? theme.color['surface/transparent/strong/press']
            : theme.color['surface/global/strong/press']};
        }

        &[aria-disabled='true'] {
          &,
          &.${menuItemClasses.selected}, &.${menuItemClasses.selected}:hover {
            opacity: initial;
            background-color: ${theme.color['base/transparent']};
            color: ${ownerState.color !== 'global'
              ? theme.color['text/disabled']
              : theme.color['text/global/disabled']};
          }

          &:before {
            display: none;
          }
        }

        &:has(> .${menuItemContentClasses.root}) {
          padding: 0;

          &[aria-disabled='true'] {
            &,
            &.${menuItemClasses.selected}, &.${menuItemClasses.selected}:hover {
              opacity: initial;
              background-color: ${theme.color['base/transparent']};
              color: ${ownerState.color !== 'global'
                ? theme.color['text/default']
                : theme.color['text/global/default']};
            }
          }
        }
      `,
    },
  },
};
